import {GlobalStoreService} from '@lemsar/storage/services/global-store.service';
import {APP_INITIALIZER, Provider} from '@angular/core';

export function useFactory(service: GlobalStoreService): Function {
    return () => service.init();
}

export const Initializer: Provider = {
    useFactory,
    provide: APP_INITIALIZER,
    deps: [GlobalStoreService],
    multi: true,
};



// WEBPACK FOOTER //
// ./apps/frontend/src/bootstrap/app.initializer.ts